import {
  Checkbox,
  Input,
  type CheckboxOnChangeData,
} from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { useOtherInfoContext } from '../OtherInfoContext';
import { FieldWrapper } from './FieldWrapper';
import { useFieldReadOnly } from './fieldReadOnly';
import type { FieldComponentProps } from './types';

export const CheckboxField = ({
  field,
  fieldValue,
  isFieldDisabled,
  validationMessage,
}: FieldComponentProps) => {
  const { t } = useTranslation();
  const { handleOtherInfoChange } = useOtherInfoContext();
  const isReadOnly = useFieldReadOnly(field);
  const isChecked = fieldValue === 'true' || fieldValue === true;

  return (
    <FieldWrapper field={field} validationMessage={validationMessage}>
      {isReadOnly ? (
        <Input
          value={isChecked ? t('yes', 'Yes') : t('no', 'No')}
          readOnly
          disabled
        />
      ) : (
        <Checkbox
          required={field.mandatory}
          checked={isChecked}
          onChange={(_, data: CheckboxOnChangeData) => {
            const value = data?.checked ?? false;
            handleOtherInfoChange(field.name, value.toString());
          }}
          disabled={isFieldDisabled}
        />
      )}
    </FieldWrapper>
  );
};
